import { Box } from '@mui/material';
import { ResponsiveTreeMap } from '@nivo/treemap';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
export default function SectorTreemap({ data }) {
    if (!data || data.length === 0) return null;

    const filtered = data.filter(s => s.name !== 'Unknown');
    if (filtered.length === 0) return null;

    const treeData = {
        name: 'Congress',
        children: filtered.map(sector => ({
            name: sector.name,
            value: sector.value,
            children: sector.children,
        })),
    };

    return (
        <ChartSection id="sector-treemap" title="Where is Congress putting its money?" subtitle="Trade volume by sector — larger rectangles = more trades">
            <Box sx={{ height: 450 }}>
                <ResponsiveTreeMap
                    data={treeData}
                    identity="name"
                    value="value"
                    margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                    label={n => n.id + ' (' + n.formattedValue + ')'}
                    labelSkipSize={40}
                    labelTextColor="#ffffff"
                    parentLabelTextColor="#ffffff"
                    borderColor="rgba(255,255,255,0.1)"
                    colors={{ scheme: 'purple_blue' }}
                    nodeOpacity={0.85}
                    parentLabelSize={16}
                    parentLabelPadding={8}
                    tooltip={({ node }) => (
                        <ChartTooltip
                            title={node.id}
                            rows={[
                                { label: 'Trades', value: node.formattedValue, color: node.color },
                                ...(node.pathComponents && node.pathComponents.length > 2
                                    ? [{
                                        label: 'Sector',
                                        value: node.pathComponents[node.pathComponents.length - 2],
                                    }]
                                    : []),
                            ]}
                        />
                    )}
                />
            </Box>
        </ChartSection>
    );
}
